module.exports = __webpack_public_path__ + "static/media/ftn-localtapiola-auth.bcf14679.svg";